import { Injectable } from '@angular/core';

import {
    Activation,
    Fai,
    FaiBox,
    FaimUnlimited,
    IPortability,
    Plan,
    Product,
    ProductFactory,
    Pto,
} from '@bytel/bytel-sales';

import { FaiService } from '@services/fai.services';

import { BasicObject } from '../interfaces/checkout.interface';
import { PtoService } from '../services/pto.service';

@Injectable({
    providedIn: 'root',
})
export class ProductApiService {
    public constructor(
        private faiService: FaiService,
        private ptoService: PtoService,
    ) {}

    public getParams(product: Product): BasicObject {
        let additionnalData: BasicObject = {};
        const defaultData: BasicObject = {
            gencode: product.gencode,
            id: product.id,
        };

        switch (true) {
            case ProductFactory.Is(product, Activation, true):
                additionnalData = { sku: product.data.sku, priceType: product.priceType };
                break;

            case ProductFactory.Is(product, FaimUnlimited, true):
                additionnalData = this._getFaimData(product as FaimUnlimited);
                break;

            case ProductFactory.Is(product, Fai, true):
                additionnalData = this._getFaiData(product as Fai);
                break;

            case ProductFactory.Is(product, FaiBox, true):
                additionnalData = this._getFaiBoxData(product as FaiBox);
                break;

            case ProductFactory.Is(product, Plan):
                additionnalData = this._getPlanData(product as Plan);
                break;
        }

        return { ...additionnalData, ...defaultData };
    }

    private _getPlanData(product: Plan): BasicObject {
        const portability: IPortability = product.portability;
        if (portability?.active && portability?.phoneNumber && portability?.codeRio) {
            return {
                rio: {
                    idPorta: portability.id,
                    noTelephoneAPorter: portability.phoneNumber,
                    phoneNumber: portability.phoneNumber,
                    codeRio: portability.codeRio,
                },
                typePortabilite: 'PORTABILITE_ENTRANTE',
            };
        }
    }

    private _getFaiData(product: Fai): BasicObject {
        return this._getPlanData(product);
    }

    private _getFaimData(product: FaimUnlimited): BasicObject {
        let homeZone: string;
        const eligBox = this.faiService.eligibility.homeZone;
        homeZone = eligBox?.box4g;
        if (product.technology === Fai.TECHNOLOGIES.BOX_5G && eligBox?.box5g) {
            homeZone = eligBox.box5g;
        }

        return {
            ...this._getFaiData(product),
            eligTechTokyo: {
                homeZone,
            },
        };
    }

    private _getFaiBoxData(product: FaiBox): BasicObject {
        let additionnalData: BasicObject = { technology: product.technology ?? this.faiService.getFaiTechnology() };

        const pto: Pto = this.ptoService.getPto();
        if (pto) {
            additionnalData = {
                ...additionnalData,
                structureVerticales: pto,
            };
        }

        if (product.appointment) {
            additionnalData = {
                ...additionnalData,
                informations: product.appointment.informations,
                appointement: product.appointment.details,
            };
        }

        if (product.schemeId >= 0) {
            additionnalData = {
                ...additionnalData,
                schemeId: product.schemeId,
            };
        }
        return additionnalData;
    }
}
